// Redux
export const ADD_REMOVE_ITEM = 'ADD_REMOVE_ITEM';
export const IS_FILTERING = 'IS_FILTERING';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_CURRENT_LIST = 'SET_CURRENT_LIST';
export const SET_LISTS = 'SET_LISTS';
export const SET_TREE = 'SET_TREE';
export const TREE_IS_LOADED = 'TREE_IS_LOADED';
export const SET_EXPANDED = 'SET_EXPANDED';
// Sagas
export const CREATE_LIST = 'CREATE_LIST';
export const DELETE_LIST = 'DELETE_LIST';
export const FETCH_LISTS = 'FETCH_LISTS';
export const FETCH_TREE = 'FETCH_TREE';
export const UPDATE_LIST = 'UPDATE_LIST';
// Other
export const SET_BANNER = 'SET_BANNER';